<template lang="pug">
  .header-logo.minimal
    img.logo(:src="logo | staticPath" alt="Logo")
</template>

<script>
import config from '@/utils/config'

export default {
  name: 'MinimalHeader',
  computed: {
    logo: {
      get () {
        return `/static/img/${config.logo}`
      }
    }
  }
}
</script>
